<template>
  <div v-if="data">
    <div v-if="data.fixedLogistics === 1 && type === 'picker'"></div>
    <div v-else>
      <new-html-part
        :data="data"
        v-if="
          data.goodsLogistics &&
          data.goodsLogistics.selfSupport === 1 &&
          !data.advanceSale
        "
      ></new-html-part>
      <old-html-part :data="data" :type="type" v-else></old-html-part>
    </div>
  </div>
</template>
<script>
import OldHtmlPart from "./components/oldHtmlPart.vue";
import NewHtmlPart from "./components/newHtmlPart.vue";
export default {
  name: "EfficiencyDate",
  components: { OldHtmlPart, NewHtmlPart },
  props: {
    type: {
      type: String,
      default: function () {
        return "";
      },
    },
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
</style>
